import { render, staticRenderFns } from "./HistoricalChannelCount.vue?vue&type=template&id=42177ede&"
import script from "./HistoricalChannelCount.vue?vue&type=script&lang=ts&"
export * from "./HistoricalChannelCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HistoricalChannelCount.vue"
export default component.exports